import { SOCKET_URL } from '@/constants/api';
import SocketService, { SocketParamBase, SocketPayload } from '@/entities/SocketService';
import { useCallback, useEffect, useState } from 'react';

const useSocket = (url: string = SOCKET_URL) => {
  const [isConnected, setIsConnected] = useState(false);
  const [socketInstance, setSocketInstance] = useState<SocketService | null>(null);

  useEffect(() => {
    if (!socketInstance) {
      const socketS = SocketService.getInstance();
      const socketInstance = socketS.connect();
      setSocketInstance(socketInstance);
      socketInstance.on('connect', () => {
        console.record('socket', 'Connected to server');
        setIsConnected(true);
      });

      socketInstance.on('disconnect', () => {
        console.record('socket', 'Disconnected from server');
        setIsConnected(false);
      });
    }

    return () => {
      if (socketInstance) {
        // socketInstance.disconnect();
        // socketInstance = null;
      }
    };
  }, [url]);

  const emitEvent = useCallback(
    (args: SocketPayload<SocketParamBase>) => {
      if (socketInstance) socketInstance.emit(args);
    },
    [socketInstance],
  );

  return { socket: socketInstance, isConnected, emitEvent };
};

export default useSocket;
